import { useQueryClient } from "@tanstack/react-query";
import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import styled from "styled-components";

// import logo from "../images/gw-logo.svg";

import Login from "./Login";
import LoginCampfireNeo from "./LoginCampfireNeo";
import ResetPassword from "./ResetPassword";

export const Styled = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5rem;
`;

/**
 * Main shadown box that contains either the login form or the reset password
 * form. */
export const LoginContainer = styled.div`
  width: 40rem;
  box-shadow: 0 20px 50px rgba(44, 85, 146, 0.1);
  border-radius: 2rem;
  border: 1px solid #ebebeb;
  padding: 3rem;
`;

const Logo = styled.div`
  text-align: center;
`;

const LoginRoute = (props: {
  loginHeader?: React.ReactNode;
  isNeo?: boolean;
}) => {
  const navigate = useNavigate();
  const client = useQueryClient();

  return (
    <Styled>
      <LoginContainer>
        <Routes>
          <Route
            path="reset"
            element={<ResetPassword onBackToLogin={() => navigate("/login")} />}
          />
          <Route
            path="*"
            element={
              props.isNeo ? (
                <LoginCampfireNeo
                  header={
                    <div>
                      <Logo>{props.loginHeader}</Logo>
                    </div>
                  }
                  onRegisterButtonClick={() => navigate("/register")}
                  allowRegistration
                  onLogin={() => {
                    client.invalidateQueries();
                    navigate("/");
                  }}
                />
              ) : (
                <Login
                  header={
                    <div>
                      <Logo>{props.loginHeader}</Logo>
                    </div>
                  }
                  onRegisterButtonClick={() => navigate("/register")}
                  allowRegistration
                  onLogin={() => {
                    client.invalidateQueries();
                    navigate("/");
                  }}
                />
              )
            }
          />
        </Routes>
      </LoginContainer>
    </Styled>
  );
};

export default LoginRoute;
